import { Box, Card, CardContent, Divider, Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MasterContent from './MasterContent';

const MasterStatus = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const title = t('masters-import.dashboard.title');

  return (
    <Card
      data-guide="dashboard-master-import-card"
      sx={{
        borderRadius: 3,
        boxShadow: 2,
        background: theme.palette.background.paper,
      }}
    >
      <CardContent>
        <Typography variant="subtitle2">{title}</Typography>
        <Divider />
        <MasterContent />
      </CardContent>
    </Card>
  );
};

export default MasterStatus;
